import React from 'react'
import clsx from 'clsx'

export const Grid = React.forwardRef((props, ref) => {
  const {
    children,
    vertical = false,
    marginX = false,
    marginY = false,
    paddingX = false,
    paddingY = false,
    smallUp = 0,
    mediumUp = 0,
    largeUp = 0,
    frame = false,
    hide = false,
    className,
    id
  } = props

  if (hide) {
    return null
  }

  let classes = clsx(
    `grid-${vertical ? 'y' : 'x'}`,
    {
      'grid-padding-y': paddingY,
      'grid-padding-x': paddingX,
      'grid-margin-y': marginY,
      'grid-margin-x': marginX
    },
    className,
    frame && 'grid-frame',
    smallUp && `small-up-${smallUp}`,
    mediumUp && `medium-up-${mediumUp}`,
    largeUp && `large-up-${largeUp}`
  )

  return <div ref={ref} id={id} className={classes}>
    {children}
  </div>
})
